import { render, staticRenderFns } from "./3.vue?vue&type=template&id=c8014cc4&scoped=true"
import script from "./3.vue?vue&type=script&lang=js"
export * from "./3.vue?vue&type=script&lang=js"
import style0 from "./3.vue?vue&type=style&index=0&id=c8014cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8014cc4",
  null
  
)

export default component.exports